/**
 * @returns {*}
 */
export function requireReactNativeRuntime() {
    throw new Error('react-native runtime unavailable in web bundle');
}
